import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { getUser } from "./lib/api";
import { registerServiceWorker } from "./lib/push";
import InstallPrompt from "./components/InstallPrompt";

import Login from "./pages/Login";
import { Forgot, Reset, Invite } from "./pages/Auth";
import IMDashboard from "./pages/IMDashboard";
import NewReferral from "./pages/NewReferral";
import OBGYNInbox from "./pages/OBGYNInbox";
import OBGYNSchedule from "./pages/OBGYNSchedule";
import OBGYNAgenda from "./pages/OBGYNAgenda";
import OBGYNManage from "./pages/OBGYNManage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUsers from "./pages/AdminUsers";
import Inbox from "./pages/Inbox";
import ReferralDetail from "./pages/ReferralDetail";

function Protected({ roles, children }) {
  const user = getUser();
  if (!user) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) {
    const dest = user.role === "im" ? "/im" : user.role === "obgyn" ? "/obgyn" : "/admin";
    return <Navigate to={dest} replace />;
  }
  return children;
}

export default function App() {
  useEffect(() => { registerServiceWorker(); }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgot" element={<Forgot />} />
          <Route path="/reset/:token" element={<Reset />} />
          <Route path="/invite/:token" element={<Invite />} />

          <Route path="/im" element={<Protected roles={["im"]}><IMDashboard /></Protected>} />
          <Route path="/im/new" element={<Protected roles={["im"]}><NewReferral /></Protected>} />

          <Route path="/obgyn" element={<Protected roles={["obgyn"]}><OBGYNInbox /></Protected>} />
          <Route path="/obgyn/agenda" element={<Protected roles={["obgyn"]}><OBGYNAgenda /></Protected>} />
          <Route path="/obgyn/manage/:id" element={<Protected roles={["obgyn"]}><OBGYNManage /></Protected>} />
          <Route path="/obgyn/:id" element={<Protected roles={["obgyn"]}><OBGYNSchedule /></Protected>} />

          <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
          <Route path="/admin/users" element={<Protected roles={["admin"]}><AdminUsers /></Protected>} />

          <Route path="/inbox" element={<Protected><Inbox /></Protected>} />
          <Route path="/referral/:id" element={<Protected><ReferralDetail /></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <InstallPrompt />
      </BrowserRouter>
    </div>
  );
}
